import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Layout from '../../components/layout';
import LOADING from '../../../views/components/loading';
import moment from 'moment';
import { 
  Button,
  PageWrapper,
  Body,
  TitleQuestion,
  WrapperQuestion,
  Subtitle,
  WrapperButton,
  Question,
  Divider,
  WrapperSuccess,
  WrapperTitle
} from '../../components/template';
import { APIRequest } from '../../../application/helper/APIRequest';
import useRouter from '../../../application/useRouter';
import InputGroup from '../../components/template/input/inputGroup';
import { colors } from '../../../styles/variables';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2'

const Answer = styled.div`
  padding: 10px 15px;
  background: #dfdfdf;
  border-radius: 5px;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 150px;
  border: 1px solid ${colors.primary.default};
  resize: none;
`;

const BackPage = styled.div`
  position: absolute;

  .icon {
    font-size: 24px;
    color: ${colors.primary.default};
    cursor: pointer;
  }
`;

const IMGBookBank = styled.img`
  width: 200px;
  height: auto;
  cursor: pointer;
`;

function DetailPage(){
  const router = useRouter();

  const [detail, setDetail] = useState();
  const [stepPage, setStepPage] = useState('detail');
  const [changeInput, setInput] = useState();

  function handleInputOnChange(e) {
    const { name, value } = e.target;
    setInput({
      ...changeInput,[name]: value
    })
  }

  function getDetail(){
    APIRequest({
      method: 'POST',
      url: '/external/form-wallet/detail',
      data: {
        transactionId: router?.query?.id
      }
    }).then(response => {
      if(response && response.code === 0) {
        setDetail(response.result);
      }
    })
  }

  function handleChangePage(action){
    setStepPage(action);
  }

  function handleActionApprove(e){
    e.preventDefault();

    APIRequest({
      method: 'PUT',
      url: '/external/form-wallet/approve',
      data: {
        transactionId: router?.query?.id,
        reference: changeInput?.reference,
        clientId: changeInput?.clientId,
        clientSecret: changeInput?.clientSecret,
        username: changeInput?.username,
        password: changeInput?.password
      }
    }).then(response => {
      if(response && response.code === 0){
        setStepPage('success')
      }
    })
  }

  function handleActionReject(e){
    e.preventDefault();

    APIRequest({
      method: 'PUT',
      url: '/external/form-wallet/reject',
      data: {
        transactionId: router?.query?.id,
        remark: changeInput?.remark
      }
    }).then(response => {
      if(response && response.code === 0){
        setStepPage('success')
      }
    })
  }

  function handleFullImage(img){
    Swal.fire({
      html: `<img src='${img}' width="100%" height="auto" />`,
      showConfirmButton: false,
      showCancelButton: false
    });
  }
  useEffect(() => {
    getDetail();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      { !detail && <LOADING /> }
      { detail &&
        <Layout>
          <PageWrapper form="true">
            <Body>
              { stepPage === 'detail' &&
                <>
                  <WrapperTitle>
                    <BackPage>
                      <Link to='/tttaaabbb'>
                        <FontAwesomeIcon className="icon" icon={faArrowCircleLeft} />
                      </Link>
                    </BackPage>
                    <h3>ตรวจสอบข้อมูล</h3>
                  </WrapperTitle>
                  <Divider color="true" />
                  <WrapperQuestion>
                    <TitleQuestion>ข้อมูลแบรนด์</TitleQuestion>
                  </WrapperQuestion>
        
                  <WrapperQuestion>
                    <Question>ชื่อแบรนด์ (ภาษาไทย)</Question>
                    <Answer>{ detail.brandNameTH }</Answer>
                  </WrapperQuestion>
        
                  <WrapperQuestion>
                    <Question>ชื่อแบรนด์ (ภาษาอังกฤษ)</Question>
                    <Answer>{ detail.brandNameEN }</Answer>
                  </WrapperQuestion>
        
                  <WrapperQuestion>
                    <TitleQuestion>ข้อมูลร้านค้า</TitleQuestion>
                  </WrapperQuestion>
                  
                  <WrapperQuestion>
                    <Question>ชื่อร้านค้า (ภาษาไทย)</Question>
                    <Answer>{ detail.shopNameTH }</Answer>
                  </WrapperQuestion>              
                  <WrapperQuestion>
                    <Question>ชื่อร้านค้า (ภาษาอังกฤษ)</Question>
                    <Answer>{ detail.shopNameEN }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <Question>ประเภทสินค้าและบริการ</Question>
                    <Answer>{ detail.type }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <Question>เบอร์โทรร้านค้า</Question>
                    <Answer>{ detail.tel }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <TitleQuestion noMargin>วันที่เริ่มต้นการใช้บริการรับชําระเงิน</TitleQuestion>
                    <Subtitle noMargin>ร้านค้าตกลงใช้บริการรับชำระเงินตามข้อตกลงและเงื่อนไขเป็นระยะเวลา 1 ปี</Subtitle>
                    <Question>วันที่</Question>
                    <Answer>{moment(detail.dateOfContract).locale('th').format('DD/MM/YYYY') || '-'}</Answer>
                  </WrapperQuestion>
        
                  <WrapperQuestion>
                    <Question>ธนาคารที่ต้องการใช้รับชำระเงิน</Question>
                    <Answer>{ detail.bankName }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <Question>ชื่อสาขา</Question>
                    <Answer>{ detail.branch }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <Question>เลขที่บัญชีธนาคาร</Question>
                    <Answer>{ detail.accountNumber }</Answer>
                  </WrapperQuestion>
        
                  <WrapperQuestion>
                    <Question>รูปหน้าบัญชีธนาคาร</Question>
                    <Answer>
                      <IMGBookBank
                        src={detail.bankPage}
                        alt="bank page"
                        onClick={ () => handleFullImage(detail.bankPage) }
                      />
                    </Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <TitleQuestion noMargin>ชื่อ-นามสกุลผู้ติดต่อ</TitleQuestion>
                    <Question>เจ้าของร้านค้า หรือผู้ที่มีหน้าที่รับผิดชอบในร้านค้า</Question>
                    <Answer>{ detail.name }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <Question>ประเภทร้านค้า</Question>
                    <Answer>{ detail.typeOfShop }</Answer>
                  </WrapperQuestion>
                  <WrapperQuestion>
                    <Question>Prefix</Question>
                    <Answer>{ detail.prefix }</Answer>
                  </WrapperQuestion>
                  <WrapperButton>
                    <Button
                      danger
                      fixWidth
                      size="small"
                      onClick={ () => handleChangePage('reject')}
                    >ปฏิเสธ</Button>
                    <Button
                      success
                      fixWidth
                      size="small"
                      onClick={ () => handleChangePage('approve')}
                    >อนุมัติ</Button>
                  </WrapperButton>
                </>
              }
              { stepPage === 'approve' &&
                <>
                  <WrapperTitle>
                    <h3>อนุมัติ</h3>
                  </WrapperTitle>
                  <Divider color="true" />
                  <form onSubmit={ (e) => handleActionApprove(e) }>
                  <WrapperQuestion>
                    <Question>Reference</Question>
                    <InputGroup
                      autoComplete="off"
                      placeholder="Reference"
                      name="reference"
                      defaultValue={changeInput?.reference}
                      onChange={ (e) => handleInputOnChange(e) }
                      required
                    />
                  </WrapperQuestion>

                  <WrapperQuestion>
                    <Question>Client ID</Question>
                    <InputGroup
                      autoComplete="off"
                      placeholder="Client ID"
                      name="clientId"
                      defaultValue={changeInput?.clientId}
                      onChange={ (e) => handleInputOnChange(e) }
                      required
                    />
                  </WrapperQuestion>

                  <WrapperQuestion>
                    <Question>Client Secret</Question>
                    <InputGroup
                      autoComplete="off"
                      placeholder="Client Secret"
                      name="clientSecret"
                      defaultValue={changeInput?.clientSecret}
                      onChange={ (e) => handleInputOnChange(e) }
                      required
                    />
                  </WrapperQuestion>

                  <WrapperQuestion>
                    <Question>Username</Question>
                    <InputGroup
                      autoComplete="off"
                      placeholder="Username"
                      name="username"
                      defaultValue={changeInput?.username}
                      onChange={ (e) => handleInputOnChange(e) }
                      required
                    />
                  </WrapperQuestion>

                  <WrapperQuestion>
                    <Question>Password</Question>
                    <InputGroup
                      autoComplete="off"
                      placeholder="Password"
                      name="password"
                      defaultValue={changeInput?.password}
                      onChange={ (e) => handleInputOnChange(e) }
                      required
                    />
                  </WrapperQuestion>

                  <WrapperButton>
                    <Button
                      danger
                      fixWidth
                      size="small"
                      type="button"
                      onClick={ () => handleChangePage('detail') }
                    >ยกเลิก</Button>
                    <Button
                      success
                      fixWidth
                      size="small"
                      type="submit"
                    >ยืนยัน</Button>
                  </WrapperButton>
                  </form>
                </>
              }
              { stepPage === 'reject' &&
                <>
                  <WrapperTitle>
                    <h3>ปฏิเสธ</h3>
                  </WrapperTitle>
                  <Divider color="true" />
                  <form onSubmit={ (e) => handleActionReject(e)}>

                  <WrapperQuestion>
                    <Question>Remark</Question>
                    <TextArea
                      autoComplete="off"
                      name="remark"
                      defaultValue={changeInput?.remark}
                      onChange={ (e) => handleInputOnChange(e) }
                      required
                    />
                  </WrapperQuestion>

                  <WrapperButton>
                    <Button
                      danger
                      fixWidth
                      size="small"
                      type="button"
                      onClick={ () => handleChangePage('detail')}
                    >ยกเลิก</Button>
                    <Button
                      success
                      fixWidth
                      size="small"
                      type="submit"
                    >ยืนยัน</Button>
                  </WrapperButton>
                  </form>
                </>
              }
              { stepPage === 'success' &&
                <>
                  <WrapperSuccess>
                    <h3>เรียบร้อย</h3>
                  </WrapperSuccess>
                  <WrapperButton>
                  <Link to='/tttaaabbb'>
                    <Button
                      primary
                      fixWidth
                      size="small"
                    >กลับหน้าหลัก</Button>
                    </Link>
                  </WrapperButton>
                </>
              }
            </Body>
          </PageWrapper>
        </Layout>
      }
    </>
  )
}

export default DetailPage;